import { FormatIcu } from "@tolgee/format-icu";
import { BackendFetch, Tolgee } from "@tolgee/web";
import { readLocale } from "#/lib/locale.ts";

import enCommon from "./messages/en/common.json";
import enLanding from "./messages/en/landing.json";
import enLearn from "./messages/en/learn.json";
import enReferrals from "./messages/en/referrals.json";
import enTrade from "./messages/en/trade.json";
import koCommon from "./messages/ko/common.json";
import koLanding from "./messages/ko/landing.json";
import koLearn from "./messages/ko/learn.json";
import koReferrals from "./messages/ko/referrals.json";
import koTrade from "./messages/ko/trade.json";
import zhCommon from "./messages/zh/common.json";
import zhLanding from "./messages/zh/landing.json";
import zhLearn from "./messages/zh/learn.json";
import zhReferrals from "./messages/zh/referrals.json";
import zhTrade from "./messages/zh/trade.json";

const cdnUrl = import.meta.env.VITE_TOLGEE_CDN_URL;
const allEnData = {
	...enCommon,
	...enLanding,
	...enLearn,
	...enReferrals,
	...enTrade,
};
const allKoData = {
	...koCommon,
	...koLanding,
	...koLearn,
	...koReferrals,
	...koTrade,
};
const allZhData = {
	...zhCommon,
	...zhLanding,
	...zhLearn,
	...zhReferrals,
	...zhTrade,
};

// 서버(빌드타임 셸 프리렌더 포함)에서도 무조건 제공 — 없으면 TolgeeProvider가
// fallback(null)을 렌더해 문서 전체가 비는다. JSON은 어차피 정적 import라
// 클라이언트 번들 비용 변화 없음.
export const TOLGEE_STATIC_DATA = {
	en: allEnData,
	ko: allKoData,
	zh: allZhData,
};

export const tolgee = Tolgee()
	.use(FormatIcu())
	.use(
		BackendFetch({
			prefix: cdnUrl,
			// CDN 실패 시 reject 대신 staticData로 폴백 (기본값 false는 throw → 언어 전환이 깨짐)
			fallbackOnFail: true,
		}),
	)
	.init({
		language: readLocale(),
		fallbackLanguage: "en",
		staticData: TOLGEE_STATIC_DATA,
	});

// staticData가 캐시를 선점해 BackendFetch가 스킵되므로(strict exists),
// 번들로 즉시 렌더한 뒤 세 언어를 CDN 최신본으로 백그라운드 갱신한다.
// loadRecords는 useCache 없이 항상 fetch하고 캐시를 덮어쓴다 → 이후
// 언어 전환도 fresh. CDN URL이 없으면(로컬 JSON 작업 등) 갱신을 끈다.
if (cdnUrl && typeof window !== "undefined") {
	void tolgee
		.loadRecords([{ language: "en" }, { language: "ko" }, { language: "zh" }], {
			noDev: true,
		})
		.catch(() => {});
}
